/**
 * @file 慧播星打点
 * @description ubc sdk用法 https://console.cloud.baidu-int.com/devops/icode/repos/baidu/jady/ubc-report-sdk/blob/master/README.md
 * @author
 */

import {ubcLogger, UbcLogger} from '@baidu/ubc-report-sdk';

const aiScriptToolId = 17597; // 脚本工具点
function log(type, params = {}, action = 'click') {
    try {
        const {value, extParam = {}} = params;
        const {logger, commonParams} = logMap[type];

        logger.send({
            ...commonParams,
            type: action,
            value,
            ext: extParam
        });

        // console.log('log =====>', {
        //     ...commonParams,
        //     type: action,
        //     value,
        //     ext: extParam
        // });
    }
    catch (e) {
        // safe log
    }
}
const AiScriptToolLogger = new UbcLogger({
    page: 'aiScriptLib',
    ev_l_t: 'click',
    serverId: aiScriptToolId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});
const logMap = {
    aiScriptTool: {
        logger: AiScriptToolLogger,
        commonParams: {
            from: 'aiScriptLib',
            pos_id: '1662__',
            ev_l_t: 'click'
        }
    }};

export const aiScriptToolLog = (tab, params) => {
    const valMap = {
        fp_script: 'fp_script', // 首页点击AI脚本
        reset: 'reset', // 重置商品信息
        generate: 'generate', // 生成商品信息
        save: 'save', // 保存到脚本库
        download: 'download', // 下载到本地
        edit: 'edit', // 编辑脚本
        library_edit: 'library_edit', // 编辑脚本库
        library_download: 'library_download', // 下载脚本库
        library_delete: 'library_delete', // 删除脚本库
        more: 'more', // 更多
        regenerate: 'regenerate', // 重新生成
        accept: 'accept', // 设置播报文案
        delete: 'delete', // 删除
        copy: 'copy', // 复制
        copy_all: 'copy_all', // 复制全部
        aihelp: 'aihelp', // AI辅写首次生成
        asr_click: 'asr_click', // 音频转文案 点击
        asr_convert: 'asr_convert', // 音频转文案 转化
        asr_user: 'asr_user' // 音频转文案 采纳文本
    };
    log('aiScriptTool', {
        value: valMap[tab],
        extParam: params
    });
};